import PropTypes from 'prop-types';

export default PropTypes.shape({
  primary: PropTypes.string,
  seo: PropTypes.string,
});
